import RequestUsersList from './RequestUsersList.vue';

export default RequestUsersList;



// WEBPACK FOOTER //
// ./src/components/parts/catalog/card/components/request/components/requestform/components/userslist/index.ts